import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { CherryDevTheme } from '../CherrySoftware/CherryDevTheme';
import {
  ProposalTabs,
  WebHero,
  WebStructure,
  WebInvestment,
  Payment,
  WebNextSteps,
  AdsHero,
  AdsFactors,
  AdsPackages,
  AdsNotes,
  AdsFinalCta,
} from './components';
import {
  NASIOL,
  WEB_PAGE_TITLE,
  WEB_PAGE_DESCRIPTION,
  ADS_PAGE_TITLE,
  ADS_PAGE_DESCRIPTION,
} from './nasiolContent';
import { useNasiolFonts } from './useNasiolFonts';

const resolveTab = (pathname, hash) => {
  const path = (pathname || '').replace(/\/+$/, '');
  if (path.endsWith('/publicidad') || hash === '#publicidad') return 'publicidad';
  if (hash === '#ecommerce' || hash === '#web') return 'ecommerce';
  return 'ecommerce';
};

const LandingNasiolInner = () => {
  const history = useHistory();
  const location = useLocation();
  const [tab, setTab] = useState(() =>
    resolveTab(location.pathname, location.hash),
  );

  useNasiolFonts(
    tab === 'publicidad' ? ADS_PAGE_TITLE : WEB_PAGE_TITLE,
    tab === 'publicidad' ? ADS_PAGE_DESCRIPTION : WEB_PAGE_DESCRIPTION,
  );

  useEffect(() => {
    setTab(resolveTab(location.pathname, location.hash));
  }, [location.pathname, location.hash]);

  const handleTabChange = useCallback(
    (next) => {
      setTab(next);
      const hash = next === 'publicidad' ? '#publicidad' : '#ecommerce';
      if (location.pathname.replace(/\/+$/, '') !== '/propuesta/nasiol') {
        history.replace(`/propuesta/nasiol${hash}`);
      } else if (location.hash !== hash) {
        history.replace({ pathname: '/propuesta/nasiol', hash: hash.slice(1) });
      }
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    [history, location.hash, location.pathname],
  );

  return (
    <Box
      sx={{
        bgcolor: NASIOL.sand,
        color: NASIOL.ink,
        fontFamily: '"Source Sans 3", "Outfit", sans-serif',
        minHeight: '100vh',
      }}
    >
      <ProposalTabs tab={tab} onChange={handleTabChange} />

      {tab === 'ecommerce' ? (
        <>
          <WebHero />
          <WebStructure />
          <WebInvestment />
          <Payment />
          <WebNextSteps />
        </>
      ) : (
        <>
          <AdsHero />
          <AdsFactors />
          <AdsPackages />
          <AdsNotes />
          <Payment />
          <AdsFinalCta onSwitchWeb={() => handleTabChange('ecommerce')} />
        </>
      )}
    </Box>
  );
};

const LandingNasiol = () => (
  <CherryDevTheme>
    <LandingNasiolInner />
  </CherryDevTheme>
);

LandingNasiol.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingNasiol;
